<div style="height: fit-content; max-height: 100%; width: 100%; position: relative; z-index: 5" [hidden]="!showBox ? showBoxClicked() : false">
  <div [ngClass]="!useFixedPosition ? 'container-standard' : 'container-fixed'">
    <div class="form-div" *ngIf="showSearchField">
      <div class="search-bar">
        <input class="search-bar-input" #inputField placeholder="Search" (input)="onInputChange(inputField.value)" />
        <img [src]="iconService.Icon.magnifier" class="form-img" />
      </div>
    </div>
    <div class="line"></div>
    <div class="top-bottom-padding" [ngStyle]="{ 'max-height': maxHeight - 43 + 'px' }">
      <div [hidden]="list.length < 1">
        <div class="items-container">
          <div *ngFor="let item of displayedList; trackBy: trackByFn">
            <div [ngClass]="['hovering-item', checkSelectedItems(item) ? 'is-selected' : '']">
              <div class="item" (click)="onItemClicked(item)">
                <img
                  class="checkbox-img"
                  [src]="checkSelectedItems(item) ? iconService.Icon.round_checkbox_grey_tick : iconService.Icon.round_checkbox_grey_empty" />
                <div class="item-content">
                  <span [ngClass]="checkSelectedItems(item) ? 'item-label-bold' : 'item-label'" class="disable-selection">{{ item.label }}</span>
                  <span *ngIf="item.subLabel" class="item-description disable-selection">{{ item.subLabel }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="no-result-text" *ngIf="displayedList.length === 0">No results</div>
        </div>
      </div>
    </div>
  </div>
</div>
